// extracted by mini-css-extract-plugin
export default {"_":"TagsIcons____mL+aC","full":"TagsIcons_full__VkInq","js":"TagsIcons_js__gXmaw","ts":"TagsIcons_ts__dix16","game":"TagsIcons_game__lokqr"};